import { render, staticRenderFns } from "./addCoupon.vue?vue&type=template&id=2605cace&"
import script from "./addCoupon.vue?vue&type=script&lang=js&"
export * from "./addCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports